export default [
  {
    path: '/modules/Attendance/attendance',
    redirect: '/modules/Attendance/attendance/Attendance',
    name: 'AttendancePage',
    component: () => import('@/views/modules/attendance/attendance/Attendance.vue'),
    meta: {
      action: [
        'ROLE_ATEND_CONSULTAR',
        'ROLE_ATENDIMENTO_CONSULTAR',
        'ROLE_AGENDAMENTO_CONSULTAR',
        'ROLE_AGENDAMENTO_CONTROLE_CONSULTAR',
      ],
      resource: 'ACL',
      pageTitle: 'Atendimento',
      breadcrumb: [
        {
          text: 'Attendance',
        },
      ],
    },
    children: [
      {
        path: 'AttendanceProfissional',
        name: 'AttendanceProfissional',
        component: () => import('@/views/modules/profissional/GridProfissional.vue'),
        meta: {
          pageTitle: 'Atendimentos',
          action: 'ROLE_PROFISSIONAL',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Profissional | Atendimentos',
            },
          ],
        },
      },
      {
        path: 'AttendanceProfissionalLegado',
        name: 'AttendanceProfissionalLegado',
        component: () => import('@/views/modules/profissional/GridProfissionalLegado.vue'),
        meta: {
          pageTitle: 'Atendimentos Legados',
          action: 'ROLE_PROFISSIONAL',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Profissional | Atendimentos Legados',
            },
          ],
        },
      },
      {
        path: 'Attendance',
        name: 'Attendance',
        component: () => import(
          '@/views/modules/attendance/attendance/grid/AttendanceGrid.vue'
        ),
        meta: {
          pageTitle: 'Atendimentos',
          action: 'ROLE_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Atendimentos',
            },
          ],
        },
      },
      {
        path: 'agendamento',
        name: 'agendamento',
        component: () => import(
          '@/views/modules/attendance/agendamento/grid/AgendamentoGrid.vue'
        ),
        meta: {
          pageTitle: 'Agendas',
          action: 'ROLE_AGENDAMENTO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Agendamentos',
            },
          ],
        },
      },
      {
        path: 'agendamentoLote',
        name: 'agendamentoLote',
        component: () => import(
          '@/views/modules/attendance/agendamentoLote/grid/AgendamentoLoteGrid.vue'
        ),
        meta: {
          pageTitle: 'Agendamentos',
          action: 'ROLE_AGENDAMENTO_CONTROLE_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Agendamentos Em Lote',
            },
          ],
        },
      },
      {
        path: 'agendamento/edit/:id',
        name: 'agendamento/edit',
        component: () => import('@/views/modules/attendance/agendamento/form/Form.vue'),
        meta: {
          pageTitle: 'editar Agendamentos',
          action: ['ROLE_AGENDAMENTO_CONSULTAR', 'ROLE_AGENDAMENTO_ATUALIZAR'],
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | editar Agendamentos',
            },
          ],
        },
      },
      {
        path: 'agendamentoEmLote/edit/:id',
        name: 'agendamentoEmLote/edit',
        component: () => import('@/views/modules/attendance/agendamentoLote/form/Form.vue'),
        meta: {
          pageTitle: 'editar Agendamentos Em Lote',
          action: ['ROLE_AGENDAMENTO_CONTROLE_CONSULTAR', 'ROLE_AGENDAMENTO_CONTROLE_ATUALIZAR'],
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | editar Agendamentos Em Lote',
            },
          ],
        },
      },
    ],
  },
]
